// lib
import { Injectable, HostListener, Injector, ComponentRef } from '@angular/core';
import { NavController, MenuController, ToastController, AlertController, ModalController, LoadingController, DomController } from '@ionic/angular';
import { ModalOptions } from '@ionic/core';
// import { ScreenOrientation } from '@ionic-native/screen-orientation';

// elvispos
import { SAMService } from '../sam/sam.service';

import { SAMMessage } from '../sam/interfaces/sam-message';
import { ConfigService } from '../config.service';
import { Keyboard } from '../base/keyboard/keyboard';
import { SpeechService } from '../services/speech.service';
import { SoundService } from '../services/sound.service';
import { ThemeService, Logger } from 'ngx-elvis-ds';
import { IMSGReadyToSell } from '../sam/interfaces/messages/ready-to-sell.interface';
import { IMSGSetNetworkStatus } from '../sam/interfaces/messages/set-network-status.interface';
import { IMSGSetGloryStatus } from '../sam/interfaces/messages/set-glory-status.interface';
import { DeviceType } from '../base/device-type.enum';
import { CartService } from '../services/cart.service';
import { JHIMService } from '../jhim/jhim.service';
import { CameraDialogPage } from './gui-dialogs/camera-dialog/camera-dialog.page';
import { GUIHelperService } from '../gui-helper.service';
import { DOMService } from '../services/dom.service';
import { CalculatorComponent } from './gui-base/calculator/calculator.component';
import { DialogsService } from '../services/dialogs.service';
import { WindowRef } from '../window-ref.service';

@Injectable({
  providedIn: 'root'
})
export class GUIService {

  welcomePageOpen: boolean = false;
  enableKeyboardListener: boolean = false;
  keyboardListenerBuffer: string = ``;
  clearKbdBufferTimeout: any = null;
  minKbdBufferLength: number = 3;

  loader: any;

  // sidemenus: { start?: SideMenu, end?: SideMenu } = {};
  comment: String = '';

  uiMessages: any = {};

  rollingMessage: {
    Mode?: string,
    Icon?: string,
    Initial?: boolean,
    Title?: string,
    Speech?: string,
    Sound?: string,
    ExpectedWeight?: string,
    Weight?: string,
  } = { Speech: '', Sound: '' };

  sessionLog = [];

  status: any = {
    online: false,
    posUpdateAvailable: false,
    glory: false,
    barSelf: true,
    scale: { CurrentWeight: 0, ExpectedWeight: 0, State: null, Locked: false },
    jhim: { 
      warning: false,
      paperLow: false,
      statusIcon: 'print',
      statusColor: () => {
        if (this.jhim.socket) {
          switch (this.jhim.socket.readyState) {
            case 1:
              if (this.status.jhim.paperLow || this.status.jhim.warning) {
                return 'warning';
              } else {
                return 'success';
              }
            case 0:
              return 'warning';
            default:
              return 'danger';
          }
        } else {
          return 'danger';
        }
      }
    }
  };

  calculator: ComponentRef<CalculatorComponent>;
  calculatorLastPos = { x: window.innerWidth - 390, y: window.innerHeight/2 - 235 };

  get toolbarColor() {
    switch (this.config.theme) {
      default:
        return "light";
    } 
  }

  toolbarTextColor(active?: boolean) {
    switch (this.config.theme) {
      case "pac2000a":
      case "conad":
        return active ? "primary" : "medium";
      default:
        return active ? "success" : "medium";
    } 
  }

  get isScrolling() {
    return this.winRef.scrolling && this.config.guiSettings.enableDragScrollFix;
  }

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private menuCtrl: MenuController,
    private toastCtrl: ToastController,
    private config: ConfigService,
    private themes: ThemeService,
    private sam: SAMService,
    private jhim: JHIMService,
    private speechSvc: SpeechService,
    private soundSvc: SoundService,
    private themeSvc: ThemeService,
    private cartSvc: CartService,
    private domCtrl: DomController,
    private guiHelperSvc: GUIHelperService,
    private domSvc: DOMService,
    private dialogSvc: DialogsService,
    private winRef: WindowRef
  ) {
  }

  initLocalKeyboard(
    formName: string,
    hostSelector?: string | undefined,
    dismissable: boolean = true,
    focus: boolean = true,
    cssClass?: string
  ) {
    if (document.forms[formName]) {
      if (/^((?!ios|android|mobile).)*chrome/i.test(navigator.userAgent)) {
        setTimeout(() => {
          const kb = new Keyboard(this.domCtrl, formName, hostSelector, focus, dismissable, cssClass);
        }, 250);
      }
    }
  }

  onSetGuiScale(event: any) {
    if (event.target && event.target.innerWidth) {
      if (event.target.innerWidth < 540) {
        this.themeSvc.GUIScale = 0.75;
      } else if (event.target.innerWidth >= 541 && event.target.innerWidth < 720) {
        this.themeSvc.GUIScale = 0.8;
      } else if (event.target.innerWidth >= 721 && event.target.innerWidth < 960) {
        this.themeSvc.GUIScale = 0.85;
      } else if (event.target.innerWidth >= 961 && event.target.innerWidth < 1140) {
        this.themeSvc.GUIScale = 0.95;
      } else {
        this.themeSvc.GUIScale = 1;
      }
    }
  }

  onNeedKeyboard() {
    this.sam.onSend({
      Command: 'NEED_KEYBOARD'
    });
  }

  onSearchItem() {
    this.sam.onSend({
      Command: 'SEARCH_ITEM'
    });
  }

  onSearchCustomer() {
    this.sam.onSend({
      Command: 'SEARCH_CUSTOMER'
    });
  }

  onCancelCustomer() {
    this.sam.onSend({
      Command: 'CANCEL_CUSTOMeR'
    });
  }

  async onOpenScandit() {
    const options: ModalOptions = {
      component: CameraDialogPage,
      backdropDismiss: false,
      cssClass: 'camera-dialog fullscreen'
    };

    const modal = await this.modalCtrl.create(options);
    await modal.present();
  }

  async onToggleCalculator() {
    if (this.calculator) {
      // close
      this.domSvc.removeComponentFromBody(this.calculator)
      this.calculator = undefined;
    } else {
      // open
      this.calculator = this.domSvc.appendComponentToBody(CalculatorComponent) as ComponentRef<CalculatorComponent>;
    }
  }

  toggleMenu(side: string, forceClose?: boolean) {
    if (forceClose) {
      this.menuCtrl.close(side);
    } else {
      this.menuCtrl.toggle(side);
    }
  }


  /**
   * Navigate to correct page depending on DeviceType
   *
   * @param {number} [deviceType]
   * @memberof GUIService
   */
  navigateByDeviceType(deviceType?: number, muteJingle?: boolean) {
    let prefix = ``;

    if (this.config.cfgDeviceId && this.config.cfgFileName) {
      prefix = `${this.config.cfgDeviceId}/${this.config.cfgFileName}`;
    }

    switch (deviceType || this.config.deviceType) {
      case DeviceType.RESTAURANT:
        this.navCtrl.navigateRoot(prefix + '/tables');
        break;
      case DeviceType.BAR:
      case DeviceType.BAR_SELF:
      case DeviceType.BAR_COMANDA:
      case DeviceType.KIOSK_SELF_ORDER:
        this.navCtrl.navigateRoot(prefix + '/pos-lite');
        this.enableKeyboardListener = true;
        break;
      case DeviceType.POS:
        this.navCtrl.navigateRoot(prefix + '/pos-full');
        this.enableKeyboardListener = true;
        break;
      case DeviceType.SCO:
        this.navCtrl.navigateForward(prefix + '/sco');
        this.enableKeyboardListener = true;
        break;
      default:
        this.navCtrl.navigateRoot(prefix + '/pos-full');
        this.enableKeyboardListener = true;
        break;
    }
    
    if (!muteJingle) {
      this.soundSvc.play('jingle');
    }
  }

  forceScreenOrientation() {
    Logger.debug('FORCE SCREEN ORIENTATION NOT IMPLEMENTED');
    // if (window.cordova && window.innerWidth >= 768) {
    //   this.screenOrientation.lock(ScreenOrientation.ORIENTATIONS.LANDSCAPE as OrientationLockType);
    // } else if (window.cordova && window.innerWidth < 768) {
    //   this.screenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT as OrientationLockType);
    // }
  }

  goTo(view: string) {
    switch (view) {
      case 'SaleView':
        if (this.config.deviceType === DeviceType.POS) {
          this.navCtrl.navigateRoot('/pos-full');
        } else {
          this.navCtrl.navigateRoot('/pos-lite');
        }
        break;
      default:
        this.navCtrl.navigateRoot('/tables');
        break;
    }
  }

  setSideMenus(menusData: any) {
    if (menusData && menusData.Functions) {
      // this.sidemenus = {
      //   start: new SideMenu(menusData.Functions.filter( f => f.Position === '0')),
      //   end: new SideMenu(menusData.Functions.filter( f => f.Position === '2'))
      // };
    }
  }

  enableSideMenus(shouldEnable: boolean) {
    this.menuCtrl.enable(shouldEnable, 'start');
    this.menuCtrl.enable(shouldEnable, 'end');
  }

  subscribeListeners() {
    document.addEventListener('keydown', this.initKeyboardListener);

    this.sam.channels.auth.subscribe((msg: SAMMessage) => {
      if (['READY_TO_SELL', 'READY_TO_ADMIN'].includes(msg.Command)) {
        // re enable menus
        if (this.config.deviceType !== DeviceType.SCO) {
          this.enableSideMenus(true);
        }

        this.guiHelperSvc.onLogin(msg.parms.DeviceId, msg.parms.User);

        // go to correct page
        const data: IMSGReadyToSell = msg.parms;
        this.config.deviceType = data.DeviceType;
        this.navigateByDeviceType(data.DeviceType);
      }
    });

    this.sam.channels.network.subscribe((msg: SAMMessage) => {
      if (['SET_NETWORK_STATUS'].includes(msg.Command)) {
        const data: IMSGSetNetworkStatus = msg.parms;
        this.status.online = (data.networkStatus === 'ONLINE' ? true : false);
      }

      if (['POS_UPDATE_AVAILABLE'].includes(msg.Command)) {
        const data = msg.parms;
        this.status.posUpdateAvailable = data.shouldUpdate;
      }

      if (['SET_GLORY_STATUS'].includes(msg.Command)) {
        const data: IMSGSetGloryStatus = msg.parms;
        this.status.glory = data.status as boolean;
      }

      if (['CMD_SET_BARSELF_STATUS'].includes(msg.Command)) {
        const data: any = msg.parms;
        this.status.barSelf = data.BarSelfStatus as boolean;
      }
    });

    this.sam.channels.gui.subscribe(async (msg: SAMMessage) => {
      if (['loader.open'].includes(msg.Command)) {
        this.loader = await this.loadingCtrl.create({ spinner: 'crescent' });
        await this.loader.present();
      }

      if (['loader.close'].includes(msg.Command)) {
        if (this.loader) {
          await this.loader.dismiss();
          this.loader = undefined;
        }
      }

      if (['sessionlog.update'].includes(msg.Command)) {
        const data: any = msg.parms;
        this.sessionLog = msg.parms as any;
      }

      if (['SET_ROLLING_MESSAGE'].includes(msg.Command)) {
        // const data: IMSGSetRollingMessage = msg.parms;
        this.speechSvc.say(msg.parms.Speech);
        this.soundSvc.play(msg.parms.Sound);
        this.rollingMessage = msg.parms as any;
      }

      if (['SET_SCALE_STATE'].includes(msg.Command)) {
        this.status.scale.State = msg.parms.State;
        this.status.scale.Locked = msg.parms.Locked;
      }

      if (['CMD_GO_TO'].includes(msg.Command)) {
        const data: any = msg.parms;
        this.goTo(data.view);
      }

      if (['SET_FUNC'].includes(msg.Command)) {
        const data: any = msg.parms;
        this.setSideMenus(data);
      }

      if (['SET_MSG'].includes(msg.Command)) {
        const data: any = <any>msg.parms;

        this.uiMessages = {
          totalField: data.totalField,
          numItemField: data.numItemField,
          itemTextField: data.itemTextField,
          customerDataField: data.customerDataField,
          opDataField: data.opDataField,
          posHeaders: [
            data.hdr1,
            data.hdr2,
            data.hdr3,
            data.hdr4,
            data.hdr5,
            data.hdr6
          ]
        };
      }

      if (['CUSTOMER'].includes(msg.Command)) {
        const data: any = <any>msg.parms;

        if (data.Val.trim() !== '') {
          this.uiMessages.customer = data.Val.trim().replace('[true]', '');

          const toast = await this.toastCtrl.create({
            message: `Cliente: ${data.Val}`,
            duration: 1000,
            position: 'top',
            color: 'danger',
            cssClass: 'custom-toast'
          });

          toast.present();
        }

        this.cartSvc.events.next();
      }

      if (['COMMENT'].includes(msg.Command)) {
        const data: any = msg.parms;
        this.comment = data.Val;
      }

      if (['SCALE_MONITOR'].includes(msg.Command)) {
        this.status.scale = msg.parms;
      }

      if (['CLEAN'].includes(msg.Command)) {
        delete this.uiMessages.customerDataField;
        delete this.uiMessages.customer;
        delete this.uiMessages.opDataField;
        if (!msg.parms.SkipCartClose) {
          this.navigateByDeviceType(null, true);
        }
      }

      if (['CLEAN_CUSTOMER'].includes(msg.Command)) {
        delete this.uiMessages.customerDataField;
        delete this.uiMessages.customer;
        this.cartSvc.events.next();
      }

      // Received when Jhim detects a low paper level on Printer
      if (['SET_JHIM_PAPERLOW'].includes(msg.Command)) {
        this.status.jhim.paperLow = msg.parms.status;

        if (this.status.jhim.paperLow) {
          this.status.jhim.statusIcon = 'fas fa-scroll';
        } else {
          this.status.jhim.statusIcon = 'print';
        }
      }

      if (['SET_JHIM_WARNING'].includes(msg.Command)) {
        this.status.jhim.warning = msg.parms.status;
      }
    });

    this.initHotkeys();
  }

  onReopenGlory() {
    this.sam.onSend({ Command: 'CMD_REOPEN_GLORY' });
  }

  onJhimReconnect() {
    this.sam.onSend({ Command: 'CMD_SELECT_DEVICE' });
  }

  onToggleSelfPOS() {
    this.sam.onSend({ Command: 'CMD_SET_BARSELF_STATUS' });
  }

  // private

  async showDebugMenu() {
    const alert = await this.alertCtrl.create({
      header: 'Debug Menu',
      buttons: [
        { text: 'Set Theme: Default', handler: () => { this.themes.apply('default'); } },
        { text: 'Set Theme: IperLANDO NEXT', handler: () => { this.themes.apply('iperlando-next'); } },
        { text: 'Set Theme: Tigros', handler: () => { this.themes.apply('tigros'); } },
        { text: 'Set Theme: Self', handler: () => { this.themes.apply('self'); } },
        { text: 'Set Theme: Crai', handler: () => { this.themes.apply('amacrai'); } },
      ]
    });

    await alert.present();
  }

  private initHotkeys() {
    // hotkeys('alt+o', (event, handler) => {
    //   switch (handler.key) {
    //     case 'alt+o': this.showDebugMenu(); break;
    //   }
    // });
  }

  private initKeyboardListener = (evt: any) => {
    const event = evt || window.event;
    let isEscape, isBackspace, isEnter;

    const hasDialogOpened = this.dialogSvc.dialogOpen;

    if (hasDialogOpened || this.enableKeyboardListener === false) {
      return true;
    }

    if ('key' in event) {
      isEscape = (event.key === 'Escape' || event.key === 'Esc');
      isBackspace = (event.key === 'Backspace' || event.key === 'Delete');
      isEnter = (event.key === 'Enter');
    } else {
      isEscape = (event.keyCode === 27);
    }

    
    if (['0','1','2','3','4','5','6','7','8','9','10'].includes(event.key)) {
      this.keyboardListenerBuffer += event.key;
      
      if (this.clearKbdBufferTimeout) {
        clearTimeout(this.clearKbdBufferTimeout);
      }
      
      if (this.keyboardListenerBuffer.length > this.minKbdBufferLength) {
        this.clearKbdBufferTimeout = setTimeout(() => {
          this.keyboardListenerBuffer = ``;
        }, 75);
      }

      return event.preventDefault();
    }

    if (isEnter) {
      if (this.keyboardListenerBuffer.length > this.minKbdBufferLength) {
        this.sam.onSend({
          Command: 'LOOKUP',
          Val: this.keyboardListenerBuffer,
          parms: {
            Qty: this.cartSvc.counters.qty
          }
        });
      }
      return event.preventDefault();
    }
  }
}
